import {ReactElement, ReactNode} from 'react'
import {Grommet} from 'grommet'

import {defaultTheme} from './themes'

interface Props {
  children?: ReactNode | undefined
}

function ShinyConfig({children}: Props): ReactElement {
  return <Grommet theme={defaultTheme}>{children}</Grommet>
}

export default ShinyConfig
